@if (copyConfigFinalised$ | async) {
  <eco-job-status-placeholder
    title="Tenant Configuration Successfully Copied!"
    subtitle="Configuration for Tenant {{ (copyFromTenant$ | async)?.Value }} was successfully copied to Tenant {{ (copyToTenant$ | async)?.Value }}."
    data-qa-id="copyconfig-export-import-success"
    >
    <div class="button-container">
      <button mat-raised-button color="accent" (click)="copyAnotherTenant()" data-qa-id="copyconfig-btn-copy-another">Copy Config from another tenant</button>
    </div>
  </eco-job-status-placeholder>
} @else {
  <form #copyConfigForm="ngForm" data-qa-id="copyconfig-export-import-form">
    <div class="row selectors-container">
      <div class="tenant">
        <div>
          <span class="title">Copy From:</span>
          <mat-select name="copyFromTenant" placeholder="Select copy from tenant" class="mat-primary"
            [(ngModel)]="copyFromTenantValue" (selectionChange)="changeCopyFrom()" data-qa-id="copyconfig-select-copy-from">
            @for (tenant of getCopyFromTenantOptions(); track tenant) {
              <mat-option [value]="tenant.Value">
                {{ tenant.Value }}
              </mat-option>
            }
          </mat-select>
        </div>
        <div class="environment" data-qa-id="copyconfig-text-copy-from-environment">
          <span class="title">Environment:</span>
          {{ copyFromEnvironment$ | async }}
        </div>
      </div>
      <div class="tenant">
        <div>
          <span class="title">Copy To:</span>
          <mat-select name="copyToTenant" placeholder="Select copy to tenant" class="mat-primary"
            [(ngModel)]="copyToTenantValue" (selectionChange)="changeCopyTo()" data-qa-id="copyconfig-select-copy-to">
            @for (tenant of (copyToTenantOptions$ | async); track tenant) {
              <mat-option [value]="tenant.Value"
                [disabled]="tenant.TenantStatus === 'LIVE'">
                {{ tenant.Value }}
              </mat-option>
            }
          </mat-select>
        </div>
        @if (copyToTenantValue) {
          <div class="environment" data-qa-id="copyconfig-text-copy-to-environment">
            <span class="title">Environment:</span>
            {{ copyToEnvironment$ | async }}
          </div>
        }
      </div>
    </div>
    @if (showInProgressMessage) {
      <div class="row">
        <mat-card class="in-progress-message" data-qa-id="copyconfig-card-in-progress-warning">
          <mat-card-content>
            <div class="in-progress-message-header">
              <mat-icon class="in-progress-message-icon">warning</mat-icon>
              Copy config already in progress
            </div>
            <p>The tenant chosen as the target to copy to already has a Copy Config in progress.</p>
            <p>You will be unable to continue with another Copy Config until the existing one is finished.</p>
            <p>You can see the progress of existing Copy Configs on the <span class="link" (click)="goToCopyConfigLogs()">Copy Config Logs Page</span>.</p>
            <p>If the existing Copy Config has failed according to the logs, and you are confident that another copy config will be more successful, you can mark it as failed there to unblock another attempt.</p>
            <p>Marking it as failed does not stop a Copy Config that is still running. There is currently no way to stop a Copy Config once it has started.</p>
          </mat-card-content>
        </mat-card>
      </div>
    }
    <div class="row">
      <div class="control-label">Copy Options:</div>
      @for (category of getOptionsCategories(); track category) {
        <div class="category-container">
          <div class="category-header">
            <span class="text-with-tooltip">
              <span class="category-name">{{ category.name }}</span>
              <mat-icon [matTooltip]="category.tooltip" matTooltipClass="multiline-tooltip"
              class="tooltip">info_outline</mat-icon>
            </span>
            <mat-checkbox class="select-all-button" [disabled]="!isSelectAllButtonAvailable(category)"
              [checked]="isAllOptionsChecked(category)" [indeterminate]="isSomeOptionsChecked(category)"
              (change)="setAllOptions(category, $event.checked)">
              Select All
            </mat-checkbox>
          </div>
          <div class="options-container">
            @for (option of category.options; track option.Identifier) {
              <div class="option text-with-tooltip">
                <mat-checkbox [(ngModel)]="option.Checked" [name]="option.Text" [disabled]="!option.Editable">
                  {{ option.Text }}
                </mat-checkbox>
                @if (option.Tooltip) {
                  <mat-icon [matTooltip]="option.Tooltip" matTooltipClass="multiline-tooltip"
                  class="tooltip">info_outline</mat-icon>
                }
              </div>
            }
            @if (!categoryHasOptions(category)) {
              <eco-no-data-placeholder
              [text]="'No options available\nPlease select a destination tenant'"></eco-no-data-placeholder>
            }
          </div>
        </div>
      }
    </div>
    <div class="row">
      <button mat-raised-button [disabled]="isCopyConfigButtonDisabled()" class="mat-accent copy-configuration-button" type="submit"
        (click)="copyConfigConfirm()" data-qa-id="copyconfig-btn-copy-configuration">
        @if (isCheckingForChanges) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <span>Copy Configuration</span>
        }
      </button>
    </div>
  </form>
}
